import type { JSX } from "react";
import { cn } from "./cn";

export interface ProjectItemProps {
  /** Project name */
  readonly name: string;
  /** Task count */
  readonly count: string;
  /** Dot color (Tailwind bg class token: "green", "blue", "orange", "red") */
  readonly dotColor: string;
  /** Extra className */
  readonly className?: string;
}

const dotColorMap: Readonly<Record<string, string>> = {
  green: "bg-green",
  blue: "bg-blue",
  orange: "bg-amber",
  red: "bg-red",
};

/**
 * A project row with a colored dot, name, and count.
 */
export function ProjectItem({ name, count, dotColor, className }: ProjectItemProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2 px-1 py-1 text-sm text-content", className)}>
      <span className={cn("w-2 h-2 rounded-full shrink-0", dotColorMap[dotColor] ?? "bg-surface-hover")} />
      {name}
      <span className="ml-auto text-xs text-content-tertiary">{count}</span>
    </div>
  );
}
